import { render, staticRenderFns } from "./StateGovernment.vue?vue&type=template&id=5f7dafec&scoped=true"
import script from "./StateGovernment.vue?vue&type=script&lang=js"
export * from "./StateGovernment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7dafec",
  null
  
)

export default component.exports